// biome-ignore format: keep array formatting as is
export const USER_CATEGORIES = [
  "culture", "technology", "business", "usPolitics", "finance", "food", "podcast", "sports", "art", "worldPolitics", "healthPolitics",
  "news", "fashionBeauty", "music", "faith", "climate", "science", "literature", "fiction", "health", "design", "travel", "parenting",
  "philosophy", "comics", "international", "crypto", "history", "humor", "education", "filmTv",
] as const

export type UserCategory = (typeof USER_CATEGORIES)[number]
